import React from "react";
import ReactDOM from "react-dom/client";
import "@/client/styles/global.css";
import "@/client/styles/wow.css";
import App from "@/client/App";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container!);
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
